import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import { getBasicDetails } from '../../../common/constants/api';
import get from 'lodash/get';
import {
  setUserName,
  getUserName,
  getUserNumber
} from '../../../common/utils/cookie-utils';
import Stepper from '../../../components/Stepper/Stepper';
import Steps from './Steps';
import FormikWizard from 'formik-wizard';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import Header from '../../../common/components/Header/Header';
import CircularLoading from '../../../common/components/CircularLoading/CircularLoading';
import SideImage from '../../../images/icons/KYCComplete.svg';
import Applicant from '../../../images/icons/applicant.svg';
import { setLoanInfo } from '../../../common/utils/LoanProcessInfo';

let isFirstLoad = true;
let stepsText = ['KYC', 'Income', 'Property'];

const icons = {
  1: <div className="text-lg">1</div>,
  2: <div className="text-lg">2</div>,
  3: <div className="text-lg">3</div>
};

function FormWrapper({
  children,
  currentStep,
  isLastStep,
  status,
  goToPreviousStep,
  canGoBack,
  steps,
  step,
  wizard,
  actionLabel
}) {
  const [applicantInformation, setApplicantInformation] = useState(false);

  useEffect(() => {
    let stepIndex;
    let doc = localStorage.hasOwnProperty('startComponent')
      ? localStorage.getItem('startComponent')
      : false;
    if (doc) {
      if (doc == 'pan') {
        stepIndex = 1;
      } else if (doc == 'aadhaar') {
        stepIndex = 2;
      } else if (doc == 'current_address_proof') {
        stepIndex = 3;
      }
      if (stepIndex) {
        wizard.push(steps.find((_, i) => i === stepIndex));
      }

      localStorage.hasOwnProperty('startComponent')
        ? localStorage.removeItem('startComponent')
        : false;
    }
  }, []);

  useEffect(() => {
    setApplicantInformation(
      localStorage.hasOwnProperty('ApplicantUserKycInfo')
        ? JSON.parse(localStorage.getItem('ApplicantUserKycInfo'))
        : false
    );
  }, []);
  const ApplicantClick = () => {
    navigate(`/app/leadprofile`);
  };

  return (
    <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
      <div className=" min-h-screen flex pt-17 md:pt-0">
        <Sidebar />
        <div className="flex-1  w-full widhtMd max-screen">
          <Header />
          <div className="flex-1 pb-8 flex-row w-full relative">
            <div className="w-full flex">
              <div className="md:ml-5  w-full md:w-8/12 px-2 md:bg-white min-h-screen md:py-2">
                <div
                  className="w-12 px-1 py-1 text-center cursor-pointer"
                  onClick={ApplicantClick}
                >
                  <img className="mr-auto w-full  rounded-md" src={Applicant} />
                  <p
                    className="font-roboto font-normal text-black-500 mx-auto"
                    style={{ fontSize: '10px' }}
                  >
                    {applicantInformation.name
                      ? `${applicantInformation.name.firstName} ${applicantInformation.name.lastName}`
                      : 'Applicant'}
                  </p>
                </div>
                <div className="overflow-x-auto">
                  <Stepper
                    // activeStep={wizard.steps.indexOf(wizard.step)}
                    activeStep={0}
                    stepsText={stepsText}
                    stepIcons={icons}
                  />
                </div>
                <div></div>
                {children}
              </div>

              <div className="w-5/12 hidden md:block">
                <img
                  className="inset-x-0 bottom-0"
                  src={SideImage}
                  style={{ position: 'fixed', bottom: 0, left: '75%' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const UserKycSteps = () => {
  setLoanInfo({ step: 'kyc' });
  const handleSubmit = React.useCallback(values => {
    return {
      message: 'Thanks for submitting!'
    };
  }, []);

  return (
    <FormikWizard steps={Steps} onSubmit={handleSubmit} render={FormWrapper} />
  );
};
export default UserKycSteps;
